import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
export function useScrollToBottom() {
  const $ = _c(13);
  const containerRef = useRef(null);
  const endRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const isAtBottomRef = useRef(true);
  const isUserScrollingRef = useRef(false);
  const isProgrammaticScrollRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== isAtBottom) {
    t0 = () => {
      isAtBottomRef.current = isAtBottom;
    };
    t1 = [isAtBottom];
    $[0] = isAtBottom;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!containerRef.current) {
        return true;
      }
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = containerRef.current;
      return scrollTop + clientHeight >= scrollHeight - 100;
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const checkIfAtBottom = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t4 => {
      const behavior = t4 === undefined ? "smooth" : t4;
      if (!containerRef.current) {
        return;
      }
      isProgrammaticScrollRef.current = true;
      setIsAtBottom(true);
      isAtBottomRef.current = true;
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior
      });
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const scrollToBottom = t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      let scrollTimeout;
      const handleScroll = () => {
        if (isProgrammaticScrollRef.current) {
          clearTimeout(scrollTimeout);
          const atBottom = checkIfAtBottom();
          if (atBottom) {
            isProgrammaticScrollRef.current = false;
          }
          scrollTimeout = setTimeout(() => {
            isProgrammaticScrollRef.current = false;
          }, 300);
          return;
        }
        isUserScrollingRef.current = true;
        clearTimeout(scrollTimeout);
        const atBottom_0 = checkIfAtBottom();
        setIsAtBottom(atBottom_0);
        isAtBottomRef.current = atBottom_0;
        scrollTimeout = setTimeout(() => {
          isUserScrollingRef.current = false;
        }, 150);
      };
      container.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        container.removeEventListener("scroll", handleScroll);
        clearTimeout(scrollTimeout);
      };
    };
    t5 = [checkIfAtBottom];
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const container_0 = containerRef.current;
      if (!container_0) {
        return;
      }
      const scrollIfNeeded = () => {
        if (isAtBottomRef.current && !isUserScrollingRef.current) {
          isProgrammaticScrollRef.current = true;
          requestAnimationFrame(() => {
            container_0.scrollTo({
              top: container_0.scrollHeight,
              behavior: "instant"
            });
            setIsAtBottom(true);
            isAtBottomRef.current = true;
            requestAnimationFrame(() => {
              isProgrammaticScrollRef.current = false;
            });
          });
        }
      };
      const mutationObserver = new MutationObserver(scrollIfNeeded);
      mutationObserver.observe(container_0, {
        childList: true,
        subtree: true,
        characterData: true
      });
      const resizeObserver = new ResizeObserver(scrollIfNeeded);
      resizeObserver.observe(container_0);
      Array.from(container_0.children).forEach(child => {
        resizeObserver.observe(child);
      });
      return () => {
        mutationObserver.disconnect();
        resizeObserver.disconnect();
      };
    };
    t7 = [];
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = function onViewportEnter() {
      setIsAtBottom(true);
      isAtBottomRef.current = true;
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const onViewportEnter = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = function onViewportLeave() {
      setIsAtBottom(false);
      isAtBottomRef.current = false;
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const onViewportLeave = t9;
  let t10;
  if ($[11] !== isAtBottom) {
    t10 = {
      containerRef,
      endRef,
      isAtBottom,
      scrollToBottom,
      onViewportEnter,
      onViewportLeave
    };
    $[11] = isAtBottom;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}